module.exports = __webpack_public_path__ + "static/media/login_icon.f78fa35e.png";